import {Action} from 'platform/components';

import i18n from '@dms/i18n';

import {buildArray, suffixTestId} from 'shared/web';

import {CarPassState} from './deriveCarPassState';

export interface GetCarPassWidgetActionsParams {
  uiState: CarPassState;
  hasDocument: boolean;
  hasDownloadableDocument: boolean;
  isDownloadingDocument: boolean;
  onRequest: () => void;
  onResolve: () => void;
  onView: () => void;
  onDownload: () => void;
  onRenew: () => void;
  onRetry: () => void;
  testId: string;
}

export function getCarPassWidgetActions(params: GetCarPassWidgetActionsParams) {
  const buildTestId = (key: string) =>
    suffixTestId(`carPassWidget-${key}`, {'data-testid': params.testId});

  return buildArray<Action>()
    .when(params.uiState === CarPassState.NONE, {
      type: 'button',
      variant: 'secondary',
      title: i18n.t('page.carPass.actions.request'),
      onClick: params.onRequest,
      'data-testid': buildTestId('request'),
    })
    .when(params.uiState === CarPassState.ACTION_REQUIRED, {
      type: 'button',
      variant: 'danger',
      leftIcon: 'alert/warning',
      title: i18n.t('page.carPass.actions.resolve'),
      onClick: params.onResolve,
      'data-testid': buildTestId('resolve'),
    })
    .when(params.uiState === CarPassState.READY, {
      type: 'button',
      variant: 'primary',
      rightIcon: 'action/launch',
      title: i18n.t('page.carPass.actions.view'),
      isDisabled: !params.hasDocument,
      onClick: params.onView,
      'data-testid': buildTestId('view'),
    })
    .when(params.uiState === CarPassState.READY, {
      type: 'button',
      variant: 'secondary',
      rightIcon: 'file/download',
      title: i18n.t('page.carPass.actions.download'),
      isDisabled: !params.hasDownloadableDocument,
      isLoading: params.isDownloadingDocument,
      onClick: params.onDownload,
      'data-testid': buildTestId('download'),
    })
    .when(params.uiState === CarPassState.EXPIRED, {
      type: 'button',
      variant: 'secondary',
      title: i18n.t('page.carPass.actions.renew'),
      onClick: params.onRenew,
      'data-testid': buildTestId('renew'),
    })
    .when(params.uiState === CarPassState.EXPIRED, {
      type: 'button',
      variant: 'secondary',
      leftIcon: 'action/launch',
      title: i18n.t('page.carPass.actions.viewPrevious'),
      isDisabled: !params.hasDocument,
      onClick: params.onView,
      'data-testid': buildTestId('viewPrevious'),
    })
    .when(params.uiState === CarPassState.EXPIRED, {
      type: 'button',
      variant: 'secondary',
      rightIcon: 'file/download',
      title: i18n.t('page.carPass.actions.download'),
      isDisabled: !params.hasDownloadableDocument,
      isLoading: params.isDownloadingDocument,
      onClick: params.onDownload,
      'data-testid': buildTestId('download'),
    })
    .when(params.uiState === CarPassState.FAILED, {
      type: 'button',
      variant: 'danger',
      title: i18n.t('page.carPass.actions.tryAgain'),
      onClick: params.onRetry,
      'data-testid': buildTestId('retry'),
    });
}
